import { assignSafe, SBaseDisplay } from '@summit/core';
import { features } from './features';

export class TenantFeatures implements SBaseDisplay {
  driverLogs: boolean;
  scheduler: boolean;
  payroll: boolean;
  maintBasic: boolean;

  constructor(jsonData?: Partial<TenantFeatures>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }

    //Different Default then Server
    //Default to False to disable features since Server should have provided

    //Correction, default to true until everyone is updated
    this.driverLogs ??= true;
    this.scheduler ??= true;
    this.payroll ??= true;
    this.maintBasic ??= true;
  }

  toShortString(): string {
    const response = [];
    if (this.driverLogs) response.push('Driver Logs');
    if (this.scheduler) response.push('Scheduler');
    if (this.payroll) response.push('Payroll');
    if (this.maintBasic) response.push('Maint. Basic');
    return response.join(', \n');
  }

  enabled(values: features[]): boolean {
    if (values.includes('core')) return true;
    if (values.includes('driverLogs') && this.driverLogs) return true;
    if (values.includes('scheduler') && this.scheduler) return true;
    if (values.includes('payroll') && this.payroll) return true;
    if (values.includes('maintBasic') && this.maintBasic) return true;
    return false;
  }
}
